<template>
    <BreadCrumb PageTitle="Liste des paiements ambulants" />
    <Paiement />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import Paiement from "../../components/PaiementAmbulant/ListePaiement.vue";
    export default defineComponent({
      name: "ListePaiementAmbulantPage",
      components: {
        BreadCrumb,
        Paiement,
      },
    });
  </script>